<template>
  <el-dialog
    title="系统状态"
    class="bc500-sys-state"
    :style="{ marginTop: '10vh' }"
    :visible="true"
    width="30%"
    :before-close="handleClose"
  >
    <div class="columns">
      <div class="column" v-for="(col, colIndex) in columns" :key="`column${colIndex}`">
        <div class="row" v-for="(row, rowIndex) in col" :key="`row${rowIndex}`">
          <span class="label">{{ row.label }}:</span>
          <RowValue :data="data" :row="row" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Socket from '@/store/modules/socket/index';
import RowValue from '@/components/row/row-value.vue';
import { getControlState, getPumpState } from '@/utils/deviceDict/bc500';

export default {
  components: { RowValue },
  props: {
    sn: {
      type: String,
      default: ''
    },
    deviceType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      columns: [
        [
          { label: '气泵状态', prop: 'pumpState', format: getPumpState },
          { label: '控制状态', prop: 'controlState', format: getControlState }
        ],
        [
          {
            label: '内存空间',
            prop: ['freeMemSize', 'totalMemSize'],
            format: val => `${val[0]}M/${val[1]}M`
          }
        ]
      ]
    };
  },
  computed: {
    data() {
      const _data = Socket.state.subDeviceMap[this.sn];
      if (!_data) return {};
      const { sysMod } = _data.mods || {};
      return {
        pumpState: sysMod.pumpRunstate,
        controlState: sysMod.controlState,
        freeMemSize: sysMod.freeMemSize,
        totalMemSize: sysMod.totalMemSize,
        batteryChargeState: sysMod.batteryChargeState
      };
    }
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      document.querySelector('.bc500-sys-state').remove();
      done();
    }
  }
};
</script>

<style lang="scss">
.bc500-sys-state {
  .columns {
    display: flex;
    justify-content: space-around;
    .column {
      display: flex;
      flex-direction: column;
      font-size: 16px;
      .row {
        padding: 10px;
        color: white;
        .label {
          color: #01cad8;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
